import { useState, useCallback } from 'react'
import effects from 'app/effects/effects'
import {
  EDIT_SUBSCRIBERS_REQUEST,
  APPROVE_SUBSCRIBER,
  GET_SUBSCRIBER_REQUEST,
  SUBSCRIBER_PASS_PERMISSION,
  SUBSCRIBER_NOT_PASS_PERMISSION,
} from '../../constants'

import * as R from 'ramda'
import {
  crmSuccessSaved,
  subscriberRejected,
  subscriberApproved,
} from './messages'
import { SUBSCRIBER_REJECT } from '../constants'
import { usePlace } from 'commons/usePlace'
import MessageAlert from 'app/components/MessageAlert'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { useFlag } from '@unleash/proxy-client-react'
import { CHANNEL_APP } from 'app/constants/channel'

const SUBSCRIBER_DETAILS_DIALOG = 'isOpenDetailsDialog'
const SUBSCRIBER_EDIT_DETAILS_DIALOG = 'isOpenEditDetailsDialog'
const SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA = 'isOpenMembershipCardDialogData'
const SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA =
  'isOpenMembershipCardListDialogData'
const SUBSCRIBER_QUICK_ACTION = 'isQuickAction'

const subscriberStatus = {
  APPROVED: 3,
  REJECT: 6,
  UNVERIFIED: 11,
}

export default (props) => {
  let {
    localState,
    setLocalState,
    pageData,
    onUpdate = () => {},
    dispatchSubscribers = () => {},
  } = props
  const { formatMessage } = useIntl()

  const apiFetchersCallback = useCallback((fetchType, params) => {
    let fetch = () => {}
    if (fetchType === EDIT_SUBSCRIBERS_REQUEST) {
      fetch = () => effects.apis.updateSubscriber(params)
    } else if (fetchType === GET_SUBSCRIBER_REQUEST) {
      fetch = () => effects.apis.getSubscriber(params)
    } else if (fetchType === APPROVE_SUBSCRIBER) {
      fetch = () => effects.apis.approveSubscriber(params)
    }

    return fetch()
  }, [])

  const dispatchRedux = useDispatch()

  const [isLoadingRequest, setIsLoadingRequest] = useState(false)
  let hasQuickAction = false

  async function getSubscriberById(subscriberId) {
    return apiFetchersCallback(GET_SUBSCRIBER_REQUEST, {
      subscriberId,
    })
  }

  function openOrCloseDetailsDialog(subscriberId) {
    if (!isLoadingRequest) {
      let isOpenDialog = !localState[SUBSCRIBER_DETAILS_DIALOG]
      openOrCloseDialogs(isOpenDialog, false, subscriberId)
    }
  }

  function quickAction(action = false) {
    hasQuickAction = action
    setLocalState((state) => ({
      ...state,
      [SUBSCRIBER_QUICK_ACTION]: hasQuickAction,
    }))
  }

  function openOrCloseEditDetailsDialog(subscriberId) {
    if (!isLoadingRequest) {
      let isOpenDetailsDialog =
        localState[SUBSCRIBER_EDIT_DETAILS_DIALOG] &&
        !localState[SUBSCRIBER_QUICK_ACTION]
      let isOpenEditDetailsDialog = localState[SUBSCRIBER_EDIT_DETAILS_DIALOG]

      if (this && this.bool !== undefined) {
        isOpenEditDetailsDialog = this.bool
        isOpenDetailsDialog = this.bool
      }

      openOrCloseDialogs(
        isOpenDetailsDialog,
        !isOpenEditDetailsDialog,
        subscriberId,
      )
    }
  }

  async function openOrCloseDialogs(
    isOpenDetailsDialog,
    isOpenEditDetailsDialog,
    subscriberId,
  ) {
    let subscriber = localState.subscriber
    if (!isNaN(subscriberId)) {
      setIsLoadingRequest(true)
      try {
        subscriber = await getSubscriberById(subscriberId)
        dispatchSubscribers({ type: SUBSCRIBER_PASS_PERMISSION })
      } catch (error) {
        dispatchSubscribers({ type: SUBSCRIBER_NOT_PASS_PERMISSION })
      }

      setIsLoadingRequest(false)
    }

    setLocalState({
      ...localState,
      [SUBSCRIBER_DETAILS_DIALOG]: isOpenDetailsDialog,
      [SUBSCRIBER_EDIT_DETAILS_DIALOG]: isOpenEditDetailsDialog,
      [SUBSCRIBER_QUICK_ACTION]: hasQuickAction,
      subscriber,
    })
  }

  function openMembershipCardDialog(subscriber) {
    if (!subscriber) {
      return
    }

    openOrCloseDetailsDialog()
    setLocalState((state) => ({
      ...state,
      [SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA]: subscriber,
    }))
  }

  function closeMembershipCardDialog(subscriber) {
    openOrCloseDetailsDialog()
    setLocalState((state) => ({
      ...state,
      [SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA]: subscriber,
      [SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA]: null,
    }))

    const subscriberId = R.path(['subscriber', 'id'], localState)
    if (subscriberId) {
      setIsLoadingRequest(true)
      getSubscriberById(subscriberId)
        .then((subscriber) => {
          setLocalState((state) => ({
            ...state,
            subscriber,
          }))
        })
        .finally(() => {
          setIsLoadingRequest(false)
        })
    }
  }

  async function updateCrmFields(subscriber, crmFields) {
    try {
      await apiFetchersCallback(EDIT_SUBSCRIBERS_REQUEST, {
        id: subscriber.id,
        ...crmFields,
      })

      pageData && pageData.refetchData()
      crmSuccessSaved(dispatchRedux)
      onUpdate()
      openOrCloseEditDetailsDialog(subscriber.id)
      return []
    } catch (e) {
      if (e.request) {
        return JSON.parse(e.request.response)
      }
    }
  }

  function closeMembershipCardListDialog() {
    openOrCloseDetailsDialog()
    setLocalState((state) => ({
      ...state,
      [SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA]: null,
    }))

    const subscriberId = R.path(['subscriber', 'id'], localState)
    if (subscriberId) {
      setIsLoadingRequest(true)
      getSubscriberById(subscriberId)
        .then((subscriber) => {
          setLocalState((state) => ({
            ...state,
            subscriber,
          }))
        })
        .finally(() => {
          setIsLoadingRequest(false)
        })
    }
  }

  function openMembershipCardListDialog(subscriber) {
    if (!subscriber) {
      return
    }

    openOrCloseDetailsDialog()
    setLocalState((state) => ({
      ...state,
      [SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA]: subscriber,
    }))
  }

  //For Open CARD DETAIL
  function openMembershipCardDetailDialog(membershipCard) {
    if (!membershipCard) {
      return
    }

    openOrCloseDetailsDialog()
    setLocalState((state) => ({
      ...state,
      [SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA]: membershipCard,
    }))
  }

  const getStatus = (action, channelSelected) => {
    if (action === SUBSCRIBER_REJECT) {
      return subscriberStatus.REJECT
    }

    const status =
      channelSelected === CHANNEL_APP
        ? subscriberStatus.APPROVED
        : subscriberStatus.UNVERIFIED

    return status
  }

  const place = usePlace()
  function approveOrReject(action, subscriberId, cb = null) {
    const channelSelected = R.compose(
      R.prop('channel'),
      R.find(R.prop('isSelected')),
      R.path(['subscriber', 'receiveMethods']),
    )(localState)

    apiFetchersCallback(APPROVE_SUBSCRIBER, {
      placeId: place.id,
      ids: [subscriberId],
      status: getStatus(action, channelSelected),
    })
      .then(() => {
        if (cb) cb()
        action === SUBSCRIBER_REJECT
          ? subscriberRejected(dispatchRedux)
          : subscriberApproved(dispatchRedux)
        openOrCloseEditDetailsDialog.apply({ bool: true }, null)
        pageData && pageData.refetchData()
      })
      .catch((error) => {
        dispatchRedux(MessageAlert.showNetworkError(formatMessage)(error))
      })
  }

  return {
    approveOrReject,
    openOrCloseDetailsDialog,
    openOrCloseEditDetailsDialog,
    updateCrmFields,
    openMembershipCardDialog,
    closeMembershipCardDialog,
    closeMembershipCardListDialog,
    openMembershipCardDetailDialog,
    openMembershipCardListDialog,
    quickAction,
  }
}
